<template>
    <div class="modal fade custom-modal" id="addBlockModal" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content custom-modal-content" v-if="projectId">
                <div class="dismiss-modal-btn" @click="closeOpenedModal()">
                  <i class="fad fa-times-circle"></i>
                </div>
                <div class="modal-header custom-modal-header">
                    <i class="fad fa-building"></i>
                    <h5 class="modal-title"> Adauga Bloc </h5>
                </div>
                <div class="modal-body custom-modal-body">
                    <form id="form-add-block">
                        <input type="hidden" name="type" value="building"/>
                        <input type="hidden" name="project" :value="projectId"/>
                        <div class="input-container">
                            <div class="flex-row align-items-end input-group mg-b">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">Bloc</span>
                                </div>
                                <input type="text" id="block-name" name="name" value="" placeholder="* Denumire bloc">
                                <label class="custom-label" for="block-name"> * Denumire bloc </label>
                            </div>
                            <p class="custom-input-error" id="name_error"></p>
                        </div>
                        <div class="input-container">
                            <div class="input-group mg-b">
                                <select name="finalized_year" id="finalized_year" v-model="currentYear" placeholder="* An finalizare">
                                  <option v-for="year in finalizedYear" :value="year.value" :key="year.value"> {{year.name}} </option>
                                </select>
                                <select name="finalized_month" id="finalized_month" v-model="currentMonth" placeholder="* Luna finalizare">
                                  <option v-for="month in finalizedMonth" :value="month.value" :key="month.value"> {{month.name}} </option>
                                </select>
                                <div class="input-icon">
                                    <i class="fad fa-calendar-day"></i>
                                </div>
                                <label class="custom-label" for="finalized_month"> * Luna finalizare </label>
                                <label class="custom-label" for="finalized_year"> * An finalizare </label>
                            </div>
                            <p class="custom-input-error" id="finalized_month_error"></p>
                            <p class="custom-input-error" id="finalized_year_error"></p>
                        </div>
                        <div class="secondary-heading">
                            <div class="secondary-heading-icon">
                                <i class="fad fa-layer-group"></i>
                            </div>
                            <span> Alege etaje </span>
                        </div>
                        <ul class="checkboxes-list">
                            <li v-for="(level, key) in definedLevels" :key="key" class="text-placeholder-radio">
                                <input type="checkbox" :id="'floor' + level.id" class="text-checkbox-input"
                                       v-model="levels"
                                       :value="level"
                                       @change="updateCheckAll()">
                                <label :for="'floor' + level.id" class="radio-input-placeholder">
                                    <span> {{level.name}} </span>
                                </label>
                            </li>
                        </ul>
                        <p class="custom-input-error" id="levels_error"></p>
                        <p class="custom-input-error" :id="`levels-${index}_error`" v-for="(lvl, index) in levels"
                           :key="`lvl-${index}`"></p>
                        <div class="general-check">
                            <input type="checkbox" id="select-all-checkboxes"
                                   class="custom-checkbox" @click="checkAll" v-model="isCheckAll">
                            <label for="select-all-checkboxes" class="custom-checkbox-label">
                                <span></span>
                                <p>
                                    Selecteaza toate etajele
                                </p>
                            </label>
                        </div>
                    </form>
                </div>
                <div class="modal-footer custom-modal-footer">
                    <button type="button" class="general-btn negative-btn" @click="dismissModal()">
                        <i class="fad fa-times-circle"></i>
                        <span> Inchide </span>
                    </button>
                    <button type="button" @click="save()" class="general-btn positive-btn">
                        <i class="fad fa-save"></i>
                        <span> Salveaza Bloc </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "AddBlockModal",
    data() {
      return {
        isCheckAll: false,
        definedLevels: [],
        levels: [],
        projectId: null,
        finalizedMonth: [
          { value: 1, name: "Ianuarie"}
          ,{ value: 2, name: "Februarie"}
          ,{ value: 3, name: "Martie"}
          ,{ value: 4, name: "Aprilie"}
          ,{ value: 5, name: "Mai"}
          ,{ value: 6, name: "Iunie"}
          ,{ value: 7, name: "Iulie"}
          ,{ value: 8, name: "August"}
          ,{ value: 9, name: "Septembrie"}
          ,{ value: 10, name: "Octombrie"}
          ,{ value: 11, name: "Noiembrie"}
          ,{ value: 12, name: "Decembrie"}
        ],
        finalizedYear: [],
        currentMonth: null,
        currentYear: null,
      }
    },
    created() {
      this.currentMonth = new Date().getMonth()+1;
      this.currentYear = new Date().getFullYear();

      let startYear = 2015;
      let endYear = new Date().getFullYear() + 5;
      let year;
      for (year = startYear;year <= endYear; year++) {
        this.finalizedYear.push({ value: year, name: year});
      }
    },
    mounted() {
      let vm = this
      this.getLevels()
      $('#addBlockModal').on('hidden.bs.modal', function () {
        $('#form-add-block').trigger("reset");
        vm.projectId = null
      });
      this.$eventBus.$on('OPEN_ADD_BUILDING_MODAL', function (payLoad) {
        vm.projectId = payLoad.projectId;
        $('#addBlockModal').modal('show')
      });
      $('#form-add-block').submit(function (e) {
        e.preventDefault();
        vm.save();
      })
    },
    methods: {
      closeOpenedModal() {
          $('#addBlockModal').modal('hide')
      },
      dismissModal() {
        $('#addBlockModal').modal('hide')
        this.projectId = null
      },
      checkAll: function () {
        this.isCheckAll = !this.isCheckAll;
        this.levels = [];

        if (this.isCheckAll) {
          for (let level in this.definedLevels) {
            this.levels.push(this.definedLevels[level]);
          }
        }
      },

      updateCheckAll: function () {
        this.isCheckAll = this.levels.length === this.definedLevels;
      },

      getLevels() {
        let vm = this;
        window.axios.get(`/get-levels`)
          .then(function (response) {
            vm.definedLevels = response.data.data;
          })
          .catch(function () {
            // console.log(err)
            // window.showError(err)
          });
      },
      save() {
        window.resetErrors()
        let vm = this;
        let myForm = document.getElementById('form-add-block');
        let lvl = [];
        for (let index = 0; index < this.levels.length; index++) {
          lvl.push(this.levels[index].id);
        }
        let formData = new FormData(myForm);
        formData.append('levels', JSON.stringify(lvl));
        window.axios.post(`/developer/${this.projectId}/building/store`, formData)
          .then(function (response) {
            window.Swal.fire({
              html: 'Blocul a fost adaugat cu succes',
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            }).then(() => {
              let building = response.data.data;
              vm.projectId = null;
              $('#addBlockModal').modal('hide')
              vm.$eventBus.$emit('BUILDING_CREATED', {
                building: building
              });
              setTimeout(() => {
                window.location.reload();
              }, 10);
            })

          })
          .catch(function (err) {
            vm.buttonDisable = false;
            window.showError(err)
          });
      }
    }
  }
</script>
